import DeviceGroupDevicesTab from './DeviceGroupDevicesTab';

export default DeviceGroupDevicesTab;
